export default __webpack_public_path__ + "static/media/menu-admin-ip.c05b20a5.png";